/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2GuestPrototypesByProjectIdAndPrototypeIdParams,
  PutV2GuestPrototypesByProjectIdAndPrototypeIdParams,
  PostV2GuestPrototypesByProjectIdParams,
  GetV2GuestPrototypesPagesByProjectIdAndPrototypeIdParams,
  PostV2GuestPrototypesPagesByProjectIdAndPrototypeIdParams,
  GetV2GuestPrototypesPartialsByProjectIdAndPrototypeIdAndPartialIdParams,
  GetV2GuestPrototypesPagesByProjectIdAndPrototypeIdAndPageIdParams,
  GetV2GuestPrototypesAiReviewsByProjectIdAndPrototypeIdParams,
  GetV2GuestPrototypesAiReviewsByProjectIdAndPrototypeIdQuery,
  PutV2GuestPrototypesByProjectIdAndPrototypeIdBody,
  PostV2GuestPrototypesByProjectIdBody,
  PostV2GuestPrototypesPagesByProjectIdAndPrototypeIdBody,
  GetV2GuestPrototypesByProjectIdAndPrototypeIdResponse,
  PutV2GuestPrototypesByProjectIdAndPrototypeIdResponse,
  PostV2GuestPrototypesByProjectIdResponse,
  GetV2GuestPrototypesPagesByProjectIdAndPrototypeIdResponse,
  PostV2GuestPrototypesPagesByProjectIdAndPrototypeIdResponse,
  GetV2GuestPrototypesPartialsByProjectIdAndPrototypeIdAndPartialIdResponse,
  GetV2GuestPrototypesPagesByProjectIdAndPrototypeIdAndPageIdResponse,
  GetV2GuestPrototypesAiReviewsByProjectIdAndPrototypeIdResponse,
} from '../types';

export class GuestPrototypes extends Controller {
  async getV2GuestPrototypesByProjectIdAndPrototypeId<
    T extends GetV2GuestPrototypesByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2GuestPrototypesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/${projectId}/prototypes/${prototypeId}`,
      axiosConfig
    );
  }

  async putV2GuestPrototypesByProjectIdAndPrototypeId<
    T extends PutV2GuestPrototypesByProjectIdAndPrototypeIdResponse,
    D,
    C extends PutV2GuestPrototypesByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PutV2GuestPrototypesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/guest/${projectId}/prototypes/${prototypeId}`,
      body,
      axiosConfig
    );
  }

  async postV2GuestPrototypesByProjectId<
    T extends PostV2GuestPrototypesByProjectIdResponse,
    D,
    C extends PostV2GuestPrototypesByProjectIdBody
  >(
    body: C,
    { projectId }: PostV2GuestPrototypesByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/guest/${projectId}/prototypes`,
      body,
      axiosConfig
    );
  }

  async getV2GuestPrototypesPagesByProjectIdAndPrototypeId<
    T extends GetV2GuestPrototypesPagesByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2GuestPrototypesPagesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/${projectId}/prototypes/${prototypeId}/pages`,
      axiosConfig
    );
  }

  async postV2GuestPrototypesPagesByProjectIdAndPrototypeId<
    T extends PostV2GuestPrototypesPagesByProjectIdAndPrototypeIdResponse,
    D,
    C extends PostV2GuestPrototypesPagesByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PostV2GuestPrototypesPagesByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/guest/${projectId}/prototypes/${prototypeId}/pages`,
      body,
      axiosConfig
    );
  }

  async getV2GuestPrototypesPartialsByProjectIdAndPrototypeIdAndPartialId<
    T extends GetV2GuestPrototypesPartialsByProjectIdAndPrototypeIdAndPartialIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
      partialId,
    }: GetV2GuestPrototypesPartialsByProjectIdAndPrototypeIdAndPartialIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/${projectId}/prototypes/${prototypeId}/partials/${partialId}`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesPagesByProjectIdAndPrototypeIdAndPageId<
    T extends GetV2GuestPrototypesPagesByProjectIdAndPrototypeIdAndPageIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
      pageId,
    }: GetV2GuestPrototypesPagesByProjectIdAndPrototypeIdAndPageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/${projectId}/prototypes/${prototypeId}/pages/${pageId}`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesAiReviewsByProjectIdAndPrototypeId<
    T extends GetV2GuestPrototypesAiReviewsByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2GuestPrototypesAiReviewsByProjectIdAndPrototypeIdParams,
    query: GetV2GuestPrototypesAiReviewsByProjectIdAndPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/guest/${projectId}/prototypes/${prototypeId}/ai/reviews`,
        query
      ),
      axiosConfig
    );
  }
}
